<template>
  <ItemList :categories="categories" :items="items" filter-mode="and-or">
    <template #default="{ item }">
      <StyleItem
        :item="item"
        :price-class="priceClass"
        :currency="currency"
        :culture="culture"
        :display-currency="displayCurrency"
        :display-exchange-rate="displayExchangeRate"
        :blob-domain="blobDomain"
      >
      </StyleItem>
    </template>
  </ItemList>
</template>

<script setup lang="ts">
import ItemList from '../../components/ItemList.vue';
import StyleItem from '../../components/StyleItem.vue';
import type Category from '../../common/Category';
import { type CatalogItem } from '../../common/CatalogItem';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<{
  categories: Category[];
  items: CatalogItem[];
  currency: string;
  culture: string;
  blobDomain: string;
  priceClass: string;
  displayCurrency: string;
  displayExchangeRate: number;
}>();
</script>
